export function formatDate(dateString) {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', {
        day: 'numeric', // 5
        month: 'short', // Aug
        year: 'numeric', // 2024
    });
}

export const formatResponseTime = (minutes) => {
if (!minutes || minutes === 0) return "N/A";
if (minutes < 60) return `${Math.round(minutes)} mins`;
return `${Math.round(minutes / 60)} hrs`;
};

export const calculateResponseTimeChange = (responseTimeData) => {
if (!responseTimeData?.previousAverageResponseTime) return 0;
if (responseTimeData?.previousAverageResponseTime === 0) return 0;

const current = responseTimeData.averageResponseTime || 0;
const previous = responseTimeData.previousAverageResponseTime;

return Math.round(((current - previous) / previous) * 100);
};